import { apiClient } from 'container/apiClient';
import { IndividualFeedbackApi } from 'api/IndividualFeedbackApi';

export const individualFeedbackApi = new IndividualFeedbackApi(apiClient);
